import { FC } from 'react';
import { MdMoreHoriz } from 'react-icons/md';
import { Dropdown } from '../../../../../components/dropdown/dropdown';
import { InfiniteScroll } from '../../../../../components/infinite-scroll/infinite-scroll';
import { DeleteModal } from '../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { TasksCreatePlannerModal } from '../tasks-create-planner-modal/tasks-create-planner-modal';
import { useTasksPlannerUtils } from '../use-task-planner-utils';
import s from './tasks-planner-cards.module.css';

interface Props {
  onEnd: () => void;
}

export const TasksPlannerCards: FC<Props> = ({ onEnd }) => {
  const {
    list,
    isLoading,
    t,
    weekDays,
    staff,
    editableModal,
    addQueryParams,
    setEditableModal,
    deleteScheduler,
    getEmployees,
    getEmployeeNames,
    getDaysOfWeek,
    getSpecialDays,
  } = useTasksPlannerUtils();

  if (!list?.length && !isLoading) {
    return <div>{t('Здесь пока нет задач')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => {
        const employees = getEmployees(staff, item.staff_ids);
        const employeeNames = getEmployeeNames(employees);
        const daysOfWeek = getDaysOfWeek(item.days_of_week, weekDays);
        const specDays = getSpecialDays(item.start_date);

        return (
          <li key={item.id} className={s.item}>
            <div className={s.top}>
              <span>
                <div className={s.title}>{t('Дни')}</div>
                <div className={s.subtitle}>{item.is_regular ? daysOfWeek : specDays}</div>
              </span>

              <HasAccess service="task" permissions={['write']}>
                <Dropdown
                  optionsClassName={s.dropdown}
                  withChevron={false}
                  leftIcon={<MdMoreHoriz className={s.actions} />}
                  closeOnSelect
                  options={[
                    {
                      label: t('Редактировать'),
                      key: 'exl',
                      onClick: () => setEditableModal(item),
                    },
                    {
                      label: t('Удалить'),
                      key: 'pdf',
                      onClick: () =>
                        addQueryParams({
                          deleteId: item.id.toString(),
                          deleteName: item.title,
                        }),
                    },
                  ]}
                />
              </HasAccess>
            </div>

            <div className={s.main}>
              <span>
                <span className={s.title} style={{ marginRight: 17 }}>
                  {t('Время начала')}
                </span>
                <span className={s.subtitle}>{item.start_time}</span>
              </span>

              <div className={s.name}>{item.title}</div>
            </div>

            <div>
              <div className={s.title}>{t('Ответственные группы')}:</div>
              <div className={s.subtitle}>{employeeNames}</div>
            </div>
          </li>
        );
      })}

      {editableModal && (
        <TasksCreatePlannerModal
          onClose={() => setEditableModal(undefined)}
          scheduler={editableModal}
        />
      )}
      <DeleteModal onSubmit={deleteScheduler} />

      <InfiniteScroll onEnterView={onEnd} />
    </ul>
  );
};
